import { Children, ReactNode, cloneElement, isValidElement } from "react"

export const addPropsToChildren = <P extends Partial<unknown>>({
  children,
  props,
}: {
  children: ReactNode
  props: P
}): ReactNode =>
  Children.map(children, (child) =>
    isValidElement(child)
      ? cloneElement(child, {
          /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
          ...(child.props as any),
          ...props,
        })
      : child
  )
